function initSliderAutoplay() {
  document.querySelectorAll('slider-component[data-autoplay="true"]').forEach((slider) => {
    if (slider.dataset.autoplayInitialized) return;
    slider.dataset.autoplayInitialized = 'true';

    const track = slider.querySelector('ul[id^="Slider-"]');
    if (!track) return;

    const originalItems = Array.from(track.children);
    if (originalItems.length < 2) return;

    // Clone the original items once and append them, so scrolling forward
    // past the last real item seamlessly continues into an identical copy
    // (a "chain" loop) instead of visibly snapping back to the start.
    originalItems.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.removeAttribute('id');
      track.appendChild(clone);
    });

    const speed = Number(slider.dataset.autoplaySpeed) || 2000;
    let paused = false;

    slider.addEventListener('mouseenter', () => {
      paused = true;
    });
    slider.addEventListener('mouseleave', () => {
      paused = false;
    });
    slider.addEventListener('touchstart', () => {
      paused = true;
    });

    setInterval(() => {
      if (paused) return;

      const items = Array.from(track.children).filter((el) => el.clientWidth > 0);
      if (items.length < 2) return;

      const itemWidth = items[1].offsetLeft - items[0].offsetLeft;
      const loopResetPoint = itemWidth * originalItems.length;

      // Once we've scrolled fully into the cloned copy, jump back to the
      // equivalent position in the original set without animating — the
      // clone is pixel-identical, so the jump is invisible to the viewer.
      if (track.scrollLeft >= loopResetPoint - 1) {
        track.scrollLeft = track.scrollLeft - loopResetPoint;
      }

      track.scrollTo({ left: track.scrollLeft + itemWidth, behavior: 'smooth' });
    }, speed);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSliderAutoplay);
} else {
  initSliderAutoplay();
}
